import { render } from "./PayloadSchema.vue?vue&type=template&id=3984756a&scoped=true"
import script from "./PayloadSchema.vue?vue&type=script&lang=js"
export * from "./PayloadSchema.vue?vue&type=script&lang=js"

import "./PayloadSchema.vue?vue&type=style&index=0&id=3984756a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3984756a"]])

export default __exports__